
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __exports as wellKnownSymbolWrapped } from '../../../_virtual/well-known-symbol-wrapped.js';
export { __exports as default } from '../../../_virtual/well-known-symbol-wrapped.js';
import wellKnownSymbol$1 from './well-known-symbol.js';

var wellKnownSymbol = wellKnownSymbol$1;

wellKnownSymbolWrapped.f = wellKnownSymbol;
//# sourceMappingURL=well-known-symbol-wrapped.js.map
